import axios from 'axios';
import apiFormat from './utils/apiFormat';
import getApiQueryStringFromData from './utils/getApiQueryStringFromData';

const api_root = __CANDY_CRM_API_HOST__;

var logoutUnAuthorisedUser = function(loggedOutMessage) {
    window.dispatchEvent(
        new CustomEvent("logoutUnAuthorisedUser", {detail: loggedOutMessage})
    );
};

class ApiDidNotReturnAValue extends Error {
    constructor(message) {
        super(message);
        // passing it to super doesn't work for some reason
        this.message = message;
    }
}

class ValidationError extends Error {
    constructor(message) {
        super(message);
        // passing it to super doesn't work for some reason
        this.message = message;
    }
}

export default {
    apiFormat(data) {
        return data;
    },
    defaultHeaders(){
        var headers = { 
            'Content-Type': 'application/json' 
        };
        let token = localStorage.getItem('token');
        if (token) {
            Object.assign(headers, {'Authorization': `Bearer ${token}`});
        } else {
            console.log("DEFAULT headers. token not found ");
        }

        return headers;
    },
    get(url, data = {}) {
        var qs = getApiQueryStringFromData(data);
        var request = {
            url: `${api_root}${url}${qs}`,
            method: 'get',
            headers: this.defaultHeaders()
        };

        return this.send(request);
    },
    put(url, data) {
        var request = {
            url: api_root + url,
            method: 'put',
            headers: this.defaultHeaders(),
            data: apiFormat(data)
        };

        return this.send(request);
    },
    delete(url, data) {
        var request = {
            url: api_root + url,
            method: 'delete',
            headers: this.defaultHeaders(),
            data: apiFormat(data)
        };

        return this.send(request);
    },
    post(url, data) {
        var request = {
            url: api_root + url,
            method: 'post',
            headers: this.defaultHeaders(),
            data: apiFormat(data)
        };

        return this.send(request);
    },   
    // ---- Plain-JSON endpoints (OPE-112 discount API) ----
    // The discount endpoints return resources directly, not the {value: ...}
    // envelope, and signal domain errors as 422 {error, reason?} or
    // 422 {error: {validation_errors}}. Same token handling as send().
    getJson(url, data = {}) {
        var qs = getApiQueryStringFromData(data);
        return this.sendJson({url: `${api_root}${url}${qs}`, method: 'get', headers: this.defaultHeaders()});
    },
    postJson(url, data = {}) {
        return this.sendJson({url: api_root + url, method: 'post', headers: this.defaultHeaders(), data: JSON.stringify(data)});
    },
    putJson(url, data = {}) {
        return this.sendJson({url: api_root + url, method: 'put', headers: this.defaultHeaders(), data: JSON.stringify(data)});
    },
    patchJson(url, data = {}) {
        return this.sendJson({url: api_root + url, method: 'patch', headers: this.defaultHeaders(), data: JSON.stringify(data)});
    },
    sendJson(request) {
        return axios(request)
            .then(response => response.data)
            .catch(error => {
                const response = error.response;
                const body = (response && response.data) || {};

                if(['token_invalid', 'token_not_provided', 'user_not_found'].includes(body.error)) {
                    logoutUnAuthorisedUser("Your credentials were invalid");
                    return new Promise(() => {});
                }
                if(body.error == 'token_expired') {
                    logoutUnAuthorisedUser("Your login expired. Please login again");
                    return new Promise(() => {});
                }

                var message = 'Something went wrong';
                if(body.error && typeof body.error === 'object' && body.error.validation_errors) {
                    var first = Object.keys(body.error.validation_errors)[0];
                    message = first ? `${first}: ${body.error.validation_errors[first][0]}` : 'Validation failed';
                } else if(typeof body.error === 'string') {
                    message = body.error == 'permission_denied' ? 'You do not have permission to do that' : body.error;
                } else if(response && response.status == 404) {
                    message = 'Not found';
                }

                if(body.error == 'feature_disabled') {
                    message = 'This feature is not enabled' + (body.client_id ? ' for this company' : '');
                }

                var err = new Error(message);
                err.status = response ? response.status : 0;
                err.reason = body.reason || null;
                if(body.error == 'feature_disabled') {
                    err.feature = body.feature;
                    err.clientId = body.client_id || null;
                }
                return Promise.reject(err);
            });
    },
    send(request) {
        return axios(request)
            .then(response => {
                if(response.data.error) {
                    return Promise.reject(new ValidationError(response.data.error));
                }

                if(! response.data.value) {
                    return Promise.reject(new ApiDidNotReturnAValue('Something went wrong.. The server did not return a value'));
                }

                return Promise.resolve(response.data);
            })
            .catch(error => {
                if(error instanceof ApiDidNotReturnAValue) {
                    return Promise.reject(error);
                }

                if(error instanceof ValidationError) {
                    return Promise.reject(error);
                }

                const response = error.response;
                console.log(response.data.error);

                if (! response.data.error) {
                    return Promise.reject(new Error('Something went wrong'));
                }

                if(response.data.error == 'user_not_found') {
                    logoutUnAuthorisedUser("User not found. Please login again");
                    return;
                }

                if(['token_invalid', 'token_not_provided'].includes(response.data.error)) {
                    logoutUnAuthorisedUser("Your credentials were invalid");
                    return;
                }

                if(response.data.error == 'token_expired') {
                    logoutUnAuthorisedUser("Your login expired. Please login again");
                    return;
                }

                return Promise.reject(new Error(response.data.error));

            });
    }
};  


// WEBPACK FOOTER //
// ./app/api.js